import httpMethod from 'services/update2025/httpMethod';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { SendReceptDataContext } from "./SendReceptDataContext";

const SendReceptDataContent = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["send-recept-data", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const sendRecptDataContext = useContext(SendReceptDataContext);

    const {
        sendReceptData,
        setSendReceptData,
        sendReceptDatas,
        setSendReceptDatas,
        sendReceptDataDialog,
        setSendReceptDataDialog,
        sendReceptDataHistoryDialog,
        setSendReceptDataHistoryDialog,
        sendReceptDataHistories,
        setSendReceptDataHistories,
        content,
        setContent,
        sendReceptDataContentDialog,
        setSendReceptDataContentDialog,
    } = sendRecptDataContext;

    const hideDialog = () => {
        setSendReceptDataContentDialog(false);
    };
    return (
        <Dialog visible={sendReceptDataContentDialog} style={{ width: "70%" }} header={t("send-receipt-data.titleDetail")} modal className="p-fluid text-left" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid mt-2" style={{ whiteSpace: "normal" }}>
                    <div className="col-12"><pre><code>{JSON.stringify(content, null, 4)}</code></pre></div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default SendReceptDataContent;
